import { option, record, string } from 'fp-ts';
import { Magma } from 'fp-ts/Magma';
import { pipe } from 'fp-ts/function';

// FP Util to determine how to merge conflicts. We're keeping a true value if it exists
const booleanMagma: Magma<boolean> = { concat: (x: boolean, y: boolean) => x || y };

// FP util to merge two Record<string, boolean> objects
export const recordMerge = record.union(booleanMagma);

// Merge two Record<string, boolean> objects into one
export function mergeRecords(
  aggregate: Record<string, boolean>,
  entry: Record<string, boolean>,
): Record<string, boolean> {
  return recordMerge(aggregate)(entry);
}

// FP util to create a parent record and merge it with child records
export const mergeRecordsWithParent =
  (path: string, collapseByDefault: boolean) => (entry: Record<string, boolean>) =>
    pipe(
      string.isEmpty(path) ? undefined : path, // Ensure the path isn't empty
      option.fromNullable, // Convert to an option
      option.map((key) => record.fromEntries([[key, collapseByDefault]])), // Create a Record<string, boolean> object for the path
      option.getOrElse<Record<string, boolean>>(() => ({})), // Ensure we have something to use as Record<string, boolean>
      recordMerge(entry), // Merge the parent record just created with the passed in child entries record
    );
